(function () {
  function bindToggle(button) {
    if (button.dataset.passwordToggleBound === 'true') return;
    button.dataset.passwordToggleBound = 'true';

    button.addEventListener('click', function (e) {
      e.preventDefault();
      var id = button.getAttribute('data-toggle-password');
      var input = document.getElementById(id);
      if (!input) return;

      var eye = button.querySelector('.icon-eye');
      var eyeOff = button.querySelector('.icon-eye-off');

      if (input.type === 'password') {
        input.type = 'text';
        if (eye) eye.style.display = 'none';
        if (eyeOff) eyeOff.style.display = 'block';
      } else {
        input.type = 'password';
        if (eye) eye.style.display = 'block';
        if (eyeOff) eyeOff.style.display = 'none';
      }
    });
  }

  function init() {
    document.querySelectorAll('.password-toggle[data-toggle-password]').forEach(bindToggle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan when sidebars/modals open dynamically (e.g. login sidebar)
  document.addEventListener('shopify:section:load', init);
})();
